import React, { useState } from "react";
import { Link } from "react-router-dom";
import ButtonLoadMore from "./ButtonLoadMore";

const FoodCategory = ({ title, category }) => {
  const [categoryCount, setCategoryCount] = useState(8);

  const loadCategories = (type) => {
    if (type === "more") {
      setCategoryCount(16);
    } else if (type === "less") {
      setCategoryCount(8);
    }
  };

  return (
    <div className="max-w-7xl mx-auto lg:w-4/5 w-11/12 text-md py-5 space-y-6  flex flex-col items-center">
      <h2 className="md:text-3xl text-2xl font-semibold text-center">
        {title}
      </h2>
      <div className="grid sm:grid-cols-4 grid-cols-2 gap-4 place-items-center text-center w-full">
        {category.slice(0, categoryCount).map((elem, index) => {
          const { name, image } = elem;
          const queryParams = new URLSearchParams({
            cuisineType: name,
          });
          return (
            <Link to={`/recipes?${queryParams}`} key={index}>
              <div className="py-5 m-auto cursor-pointer">
                <img
                  src={image}
                  alt={name}
                  title={name}
                  className="rounded-full bg-red-100 w-28 aspect-square flex flex-shrink-0 object-cover sm:w-28 lg:w-40"
                />
                <p>{name}</p>
              </div>
            </Link>
          );
        })}
      </div>
      {categoryCount === 8 && <ButtonLoadMore onClick={loadCategories} value="more"/>}
      {categoryCount === 16 && <ButtonLoadMore onClick={loadCategories} value="less" />}
    </div>
  );
};

export default FoodCategory;
